import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from './../../../../../services/auth.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { HelperService } from './../../../../../services/helper.service';

import _ from 'lodash';

@Component({
  selector: 'app-create-hotspots',
  templateUrl: './create-hotspots.component.html',
  styleUrls: ['./create-hotspots.component.scss']
})
export class CreateHotspotsComponent implements OnInit, OnChanges {
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Input() selectedMesh;
  @Input() editHotspots;
  @Output() createHotspotEmit = new EventEmitter();
  @Output() deleteHotspotEmit = new EventEmitter();
  @Output() updateHotspotEmit = new EventEmitter();
  @Output() closeHotSpotBoxEmit = new EventEmitter();
  @Output() changeColorEmit = new EventEmitter();
  @Output() updateHotspotOrientationEmit = new EventEmitter();

  createHotspotForm: FormGroup;
  accessToken: any;
  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  selectedImage: any;

  isSetOrientationClicked = false;
  orientation = null;

  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.createHotspotsFormInit();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // debugger;
    if (changes && changes.editHotspots && changes.editHotspots.currentValue) {
      this.resetFormValues(changes.editHotspots.currentValue);
    } else {
      this.resetFormValues(undefined);
    }
  }

  createHotspotsFormInit() {
    this.createHotspotForm = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(40)]],
      media_link_id: ['', [Validators.required]],
      color: ['#ffc378', [Validators.required]],
    });
  }

  submit(value) {
    if (!this.createHotspotForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.type = '2D';
    data.media_id = this.selectedMedia.uuid;
    data.coordinates = this.selectedMesh.position;
    data.orientation = this.orientation;
    if (this.editHotspots) {
      this.updateHotspots(data);
    } else {
      this.createHotspots(data);
    }
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  createHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.createHotspot({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'New hotspot was successfuly created.';
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.createHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  updateHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateHotspot({
      Authorization: this.accessToken,
      id: this.editHotspots.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Hotspot was successfuly updated.';
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.updateHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues(undefined);
  }

  resetFormValues(data) {
    if (!data) {
      this.createHotspotForm.reset({
        title: '',
        media_link_id: '',
        color: '#ffc378'
      });
    } else {
      this.createHotspotForm.reset({
        title: data.title,
        media_link_id: data.media_link ? data.media_link.uuid : '',
        color: data.color && data.color !== '' ? data.color : '#ffc378'
      });
      this.selectedImage = _.find(this.mediaData, {uuid: data.media_link ? data.media_link.uuid : '' });
      this.orientation = data.orientation ? data.orientation : undefined;
    }
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating hotspot.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.isSubmitting = false;
    this.isSubmitted = false;
  }

  deleteHotspot() {
    this.deleteHotspotEmit.emit('link');
  }

  modalCloseEmit(hotspot) {
    if ($('#deleteModal')) {
      $('#deleteModal').modal('hide');
    }
    if (hotspot) {
      this.deleteHotspotEmit.emit(hotspot);
    }
  }

  closeHotSpotBox() {
    this.closeHotSpotBoxEmit.emit('link');
  }

  selectImage(media) {
    this.selectedImage = media;
    this.createHotspotForm.get('media_link_id').setValue(this.selectedImage.uuid);
  }

  setOrientationClick() {
    this.isSetOrientationClicked = true;
  }

  setInitialViewEmit(response) {
    if ($('#orientationModal')) {
      $('#orientationModal').modal('hide');
    }
    this.isSetOrientationClicked = false;
    this.isSetOrientationClicked = false;
    if (response) {
      this.orientation = response;
      if (this.editHotspots) {
        const data = {
          orientation: this.orientation
        };
        this.updateHotspotOrientation(data);
      }
    }
  }

  changeColor(color) {
    this.changeColorEmit.emit(color);
  }

  updateHotspotOrientation(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateHotspotOrientation({
      Authorization: this.accessToken,
      id: this.editHotspots.uuid,
      body: formData
    }).subscribe((response: any) => {
      const responseData = response && response.data ? response.data : undefined;
      this.updateHotspotOrientationEmit.emit(responseData);
    }, err => {
      if (err.error && err.error.errors) {
        this.errors = err.error.errors;
      } else if (err.error && err.error.error) {
        this.errorMsg = err.error.error;
      } else {
        this.errorMsg = 'There was error while updating hotspot orientation.';
      }
      setTimeout(() => {
        this.resetErrors();
      }, 5000);
    });
  }

}
